var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import LicenseService from '../../../api/LicenseService';
import GoodService from '../../../api/GoodService';
var initFormData = {
    goods_type_id: null,
    keywords: '',
    dimension: 1
};
var BindGoodsHeader = (function (_super) {
    __extends(BindGoodsHeader, _super);
    function BindGoodsHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.groups = [];
        _this.categoryData = [];
        return _this;
    }
    BindGoodsHeader.prototype.watchShowStockGoods = function (newValue, oldValue) {
        this.search();
    };
    BindGoodsHeader.prototype.created = function () {
        this.service = LicenseService.getInstance();
        this.goodService = GoodService.getInstance();
        this.getCategory();
    };
    BindGoodsHeader.prototype.mounted = function () {
        this.search();
    };
    BindGoodsHeader.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    BindGoodsHeader.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    BindGoodsHeader.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    __decorate([
        Watch("formData.dimension")
    ], BindGoodsHeader.prototype, "watchShowStockGoods", null);
    BindGoodsHeader = __decorate([
        Component({
            components: {}
        })
    ], BindGoodsHeader);
    return BindGoodsHeader;
}(Vue));
export default BindGoodsHeader;
